import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";

import magnifiAPI from "../../services/api/magnifi";
import { studioProjectsGroupByDate } from "../schemas";

export const getStudioProjectLists = createAsyncThunk("studioProjects/getStudioProjectLists", async (payload) => {
  try {
    const response = await magnifiAPI.getNewIllustoProjectsClips(payload);
    const studioProjectsData = response.data?.groupByDatepProjects || {};

    // sorting clips based on updatedAt, to show latest clips on top for a particular date
    studioProjectsData.forEach(
      (project) =>
        (project.data = project.data?.sort((a, b) => new Date(b?.clip?.updatedAt) - new Date(a?.clip?.updatedAt))),
    );

    const normalizedData = normalize(studioProjectsData, [studioProjectsGroupByDate]);

    return {
      ...response.data,
      ...(response.data.success ? normalizedData : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getStudioProjectsRedirectUrl = createAsyncThunk(
  "clipList/getStudioProjectsRedirectUrl",
  async (payload) => {
    try {
      const response = await magnifiAPI.getStudioProjectsRedirectUrl(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const deleteStudioProject = createAsyncThunk("clipList/deleteStudioProject", async (payload) => {
  try {
    const response = await magnifiAPI.deleteStudioProject(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
